import { classNames } from "../../../../../shared/lib/classNames";
import styles from "../PersonalDataText/PersonalDataText.module.scss";

interface PersonalDataTextVacancyProps {
    className?: string;
}

export const PersonalDataTextVacancy = ({ className }: PersonalDataTextVacancyProps) => {
    return (
        <div className={classNames({ cls: styles.personalDataText, additional: [className] })}>
            <p>
                Настоящим Я, действуя своей волей и в своем интересе, при направлении резюме Операторам, указании персональных данных, размещении документов или их копий (в том числе в электронном виде), содержащих мои персональные данные, в личном кабинете или форме обратной связи карьерного сайта{" "}
                <a href="https://bcs.career/" target="_blank" rel="noopener noreferrer">
                    https://bcs.career/
                </a>{" "}
                или отправке персональных данных через иные ресурсы в том числе: фамилии, имени, отчества, города проживания, номера мобильного телефона, адреса электронной почты, сведений об образовании, опыте работы, о желаемой должности, резюме (портфолио), предоставляю каждому в отдельности и совместно:
            </p>
            <br />
            
            <p className={styles.personalDataText__table}>
                ООО «Компания Брокеркредитсервис» (630099, г. Новосибирск, ул. Советская д. 37),
            </p>
            <p className={styles.personalDataText__table}>
                АО «БКС Банк» (г. Москва, вн.тер.г. муниципальный округ Тверской, ул. 4-я Тверская-Ямская, д. 14, стр. 1),
            </p>
            <p className={styles.personalDataText__table}>
                АО Управляющая Компания «Брокеркредитсервис» (129110, г. Москва, Проспект Мира, 69, строение 1),
            </p>
            <p className={styles.personalDataText__table}>
                АО "БКС Управление благосостоянием" (129110, ГОРОД МОСКВА, МИРА ПРОСПЕКТ, ДОМ 69, СТРОЕНИЕ 1),
            </p>
            <p className={styles.personalDataText__table}>
                ООО "БКС - Форекс" (129110, ГОРОД МОСКВА, МИРА ПРОСПЕКТ, ДОМ 69, СТРОЕНИЕ 1),
            </p>
            <p className={styles.personalDataText__table}>
                ООО СК «БКС Страхование жизни» (129110, ГОРОД МОСКВА, МИРА ПРОСПЕКТ, ДОМ 69, СТРОЕНИЕ 1),
            </p>
            <p className={styles.personalDataText__table}>
                ООО "Консультационный Центр БКС" (129110, ГОРОД МОСКВА, МИРА ПРОСПЕКТ, ДОМ 69, СТРОЕНИЕ 1),
            </p>
            <p className={styles.personalDataText__table}>
                ООО "Финансовый Консалтинг" (630099, НОВОСИБИРСК ГОРОД, СОВЕТСКАЯ УЛИЦА, ДОМ 37),
            </p>
            <p className={styles.personalDataText__table}>
                ООО "Юрейжн Партнерс" (местонахождение: 129110, РОССИЯ, Г. МОСКВА, МИРА ПР-КТ, Д. 69, СТР. 1),
            </p>
            <p className={styles.personalDataText__table}>
                ООО "БКС Финтех" (129110, Г. МОСКВА, Н.ТЕР.Г. МУНИЦИПАЛЬНЫЙ ОКРУГ МЕЩАНСКИЙ, МИРА ПР-КТ, Д. 69, СТР. 1),
            </p>
            <p className={styles.personalDataText__table}>
                ООО «Брокеркредитсервис Технологии» (Российская Федерация, 630099, г. Новосибирск, ул. Советская д. 37),
            </p>
            <p className={styles.personalDataText__table}>
                ООО "БКС Холдинг» (ГОРОД НОВОСИБИРСК, СОВЕТСКАЯ УЛ., Д. 37),
            </p>
            <p className={styles.personalDataText__table}>
                ООО "БКС ФТ" (129110, Г.МОСКВА, ВН.ТЕР.Г. МУНИЦИПАЛЬНЫЙ ОКРУГ МЕЩАНСКИЙ, ПР-КТ МИРА, Д. 69, СТР. 1, ПОМЕЩ. 1/5),
            </p>
            <p className={styles.personalDataText__table}>
                (далее – Оператор, а совместно именуемые – Операторы),
            </p>
            <br />

            <p>
                согласие на автоматизированную, а также осуществляемую без использования средств автоматизации (с использованием различных материальных носителей, включая бумажные носители) обработку моих персональных данных, а именно: на сбор, запись; систематизацию, накопление, хранение, уточнение (обновление, изменение), извлечение, использование, передачу (предоставление, доступ), обезличивание, блокирование, удаление и уничтожение с целью оценки меня в качестве кандидата на открытую Оператором вакантную позицию и определения возможности трудоустройства у Оператора.
            </p>
            <br />

            <p>
                Достижение указанной цели обработки персональных данных Оператором предполагает организацию следующих процессов и выполнение следующих задач:
            </p>
            <br />

            <p>- Содействие в трудоустройстве.</p>
            <br />
            <p>- Оценку профессиональных знаний и навыков субъекта персональных данных, тестирование субъекта персональных данных.</p>
            <br />
            <p>- Принятие решения о трудоустройстве.</p>
            <br />
            <p>- Формирование кадрового резерва.</p>
            <br />
            <p>- Ведение кадрового, бухгалтерского, налогового и воинского учета в случае принятия положительного решения о трудоустройстве.</p>
            <br />
            <p>- Оформление трудового договора и совершение иных формальностей при оформлении трудовых отношений в случае принятия положительного решения о трудоустройстве.</p>
            <br />
            <p>- Соблюдение требований применимого законодательства, включая трудовое законодательство, Гражданский кодекс РФ, Налоговый кодекс РФ, миграционное законодательство, и иных правил, инструкций, нормативных актов и процедур, внутренних нормативных актов Оператора, а также для оценки такого соблюдения.</p>
            <br />
            <p>- Получение рекомендаций от предыдущих работодателей.</p>
            <br />
            <p>- Проверку и подтверждение достоверности данных о профессиональном опыте, трудовом стаже, и иных данных, представленных Субъектом персональных данных. в том числе с помощью общедоступных источников в сети Интернет, включая публичные профили в социальных сетях, и запроса информации у третьих лиц.</p>
            <br />
            <p>- Иные законные задачи и процессы, осуществление которых совместимо с указанной целью обработки персональных данных.</p>
            <br />

            <p>
                Настоящее согласие действует до достижения Оператором (Операторами) вышеуказанной цели обработки персональных данных за исключением случаев, когда более длительный срок обработки персональных данных предусмотрен действующим законодательством Российской Федерации.
            </p>
            <br />

            <p>
                Я проинформирован о том, что на основании настоящего согласия буду включен в кадровый резерв каждого из Операторов. Персональные данные в кадровом резерве хранятся до ликвидации Оператора, если не будут исключены по на основании:
            </p>
            <br />
            <p>- решения руководителя Оператора;</p>
            <br />
            <p>- личного заявления лица, состоящего в кадровом резерве, об исключении из кадрового резерва одного или нескольких Операторов;</p>
            <br />
            <p>- отзыва субъектом персональных данных соответствующего согласия на обработку персональных данных.</p>
            <br />

            <p>
                Настоящее согласие может быть отозвано в любой момент путем направления письменного заявления Операторам на электронный адрес{" "}
                <a href="mailto:job@bcs.ru">job@bcs.ru</a>{" "}
                или на почтовый адрес Операторов, что будет являться основанием для исключения из кадрового резерва.
            </p>
            <br />

            <p>
                В случае, если для цели, указанной в настоящем согласии, субъект персональных данных предоставляет Операторам данные третьих лиц (в том числе указывает в резюме контакты лиц, которые могут предоставить ему рекомендации), он гарантирует, что получил согласие таких лиц на передачу и обработку и бессрочное хранение их персональных данных со стороны Операторов на условиях, описанных в настоящем согласии.
            </p>
            <br />

            <p>
                В случае претензий таких лиц к Операторам по факту неправомерной обработки персональных данных, субъект обязуется урегулировать такие претензии самостоятельно и за свой счет. Кроме того, субъект уполномочивает Операторов предоставлять третьему лицу по его запросу информацию об источнике получения его персональных данных (включая его фамилию, имя, отчество и контактные данные).
            </p>
        </div>
    );
};